// noinspection JSUnresolvedFunction,JSUnresolvedVariable,DuplicatedCode

import React, { useEffect, useMemo, useRef, useState } from "react";
import DataTable from 'components/Core/DataTable';

import {
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	Row,
	Col,
	Button,
	ModalHeader,
	ModalBody,
	Form,
	FormGroup,
	Label,
	Input,
	ModalFooter,
	Modal,
	CustomInput,
	Collapse
} from "reactstrap";
import { MotionButton } from "../components/Core/MotionStrap";
import NotificationAlert from "react-notification-alert";
import Supplier from "../lib/Core/Backend/Controllers/Supplier";
import Notify from "../lib/Utils/Alert";
import Utils from "../lib/Utils/Utils";
import ContactsCtl from "../components/Supplier/ContactsCtl";
import BrandsCtl from "../components/Supplier/BrandsCtl";
import APICredential from "components/Supplier/APICredential";
import LayoutFileForm from "../components/Supplier/LayoutFileForm";
import FormValidator from "../lib/Utils/FormValidator";
import BaseModal from "../components/Core/BaseModal";
import CardType from "../lib/Core/Backend/Controllers/CardType";
import SkuMapping from "lib/Core/Backend/Controllers/SkuMapping";
import useBrands from "hooks/useBrands";
import $, { error } from 'jquery';
import useCatalogs from "hooks/useCatalogs";
import Spinner from 'react-bootstrap/Spinner';
import PurchaseOrdersBySupplier from "components/Supplier/PurchaseOrdersBySupplier";
import ConfirmationAlert from '../components/ConfirmationAlert/ConfirmationAlert';
import PurchaseOrder from "lib/Core/Backend/Controllers/PurchaseOrder";
import * as modalCSVcss from "../components/Supplier/css/modalUploadCSV.module.css";
import { ReactComponent as UploadIcon } from "../assets/img/upload.svg";
import okIMG from "../assets/img/ok.png";
import Purchaser from "../lib/Core/Backend/Controllers/Purchaser";
import { BsInfoCircle } from "react-icons/bs";
import { useHistory } from "react-router";
const mapKeys = {
	mainPhone: 'mainPhone',
	name: 'name',
	website: 'website',
	city: 'city',
	countryId: 'countryId',
	postalCode: 'zipcode',
	street: 'street',
	paymentOptionId: 'paymentTypeId',
	thresholdAmount: 'paymentTypeAmount',
	purchaseDiscount: 'purchaseDiscount',
	purchaseFee: 'purchaseFee'
}

function SupplierView(props) {
	const { token, accessRoles } = props;
	const purchaseOrderCtl = useMemo(() => new PurchaseOrder(token), [token]);
	const brands = useBrands();
	const { countries, paymentOptions, contactTypes } = useCatalogs()
	const supplierCtl = useMemo(() => new Supplier(token), [token]);
	const cardTypeCtl = useMemo(() => new CardType(token), [token]);
	const skuMappingCtl = useMemo(() => new SkuMapping(token), [token])
	
	const [upload, setUpload] = useState(false);
	const [isProcessing, setIsProcessing] = useState(false);

	const [modal, setModal] = useState(false);
	const [confirmModal, setConfirmModal] = useState(false);
	const [historyModal, setHistoryModal] = useState(false);
	const toggle = () => setModal(!modal);
	const toggleConfirm = () => setConfirmModal(!confirmModal);
	const toggleHistory = () => {
		setHistoryModal(!historyModal);
	};

	const [activeOp, setActiveOp] = useState("");
	const [activeOpText, setActiveOpText] = useState("");
	const [operativeRow, setOperativeRow] = useState(null);
	const [bulkLayout, setBulkLayout] = useState(null);
	const purchaserCtl = useMemo(() => new Purchaser(token), [token]);

	const [apiCredInfo, setApiCredInfo] = useState(false);
	const [fileLayoutInfo, setFileLayoutInfo] = useState(false);
	const [selectedOption, setSelectedOption] = useState({});
	const [contactModal, setContactModal] = useState(false);
	const [brandModal, setBrandModal] = useState(false);
	const [activeContact, setActiveContact] = useState(null);
	const [activeBrand, setActiveBrand] = useState(null);
	const [cardTypes, setCardTypes] = useState([]);
	const [brandFilter, setBrandFilter] = useState([]);
	const [brandOperation, setBrandOperation] = useState('');
	const [supplierCardCatalog, setSupplierCardCatalog] = useState([]);
	const [mappings, setMappings] = useState([]);
	const [disableSelect, setDisableSelect] = useState(false);
	const [extraCardTypeInfo, setExtraCardTypeInfo] = useState(false);
	const [extraBrandInfo, setExtraBrandInfo] = useState(false);
	const [isVariable, setIsVariable] = useState(false);
	const [suppliers, setsuppliers] = useState([]);
	const [isSupplierAPI, setIsSupplierAPI] = useState(false);
	const stayModal = () => setShowAlertMessage(false)
	const [showAlertMessage, setShowAlertMessage] = useState(false)
	const [loading, setLoading] = useState(false)

	const [supplierInformation, setSupplierInformation] = useState({})
	const [cardTypeTableInformation, setCardTypeTableInformation] = useState([])
	const [deleteFlag, setDeleteFlag] = useState({})
	const [fileCsv, setFileCsv] = useState(null);
	
	const[productName,setProductName]= useState("")
	const [currencyId,setCurrencyId] = useState("")
	const [currencyName,setCurrencyName] = useState("")
	const[amount,setAmount] = useState(0)
	 const[minimumAmount,setMinimumAmount] = useState(0)
	 const[maximumAmount,setMaximumAmount]= useState(0)
	 const [isAddressInfoOpen,setIsAddressInfoOpen] = useState(false);
	 const [isPaymentOptions,setIsPaymentOptions]= useState(false);
	 const [isFundThreshold,setIsFundThreshold] = useState(false)
	 const [isFeesandDiscount,setisFeesandDiscount] = useState(false);
	 const [isContactInfoOpen,setIsContactInfoOpen]= useState(false);
	 const [isSupplierBrandInfo,setIsSupplierBrandInfo] = useState(false);
	 const [latestAddedBrand, setLatestAddedBrand] = useState({});
     const [supplierName,setSupplierName] = useState("");
	 const [thresholdValue,setThrsholdValue] = useState()
	 const [supplierBalance,setSupplierBalance] = useState()
	 const [fundTableData,setFundTableData] = useState({})
     const [fundDetailsData,setFundDetailsData] = useState({});
	 const [callFundApi,setCallFundApi] = useState(0)
	 const [loaderOne,setLoaderOne] = useState(false);
	 const [loaderTwo,setLoaderTwo] = useState(false);
	 const [loaderThree,setLoaderThree] = useState(false);
	 const [loaderFour,setLoaderFour] = useState(false);
	 const [loaderFive,setLoaderFive] = useState(false);
	 const [loaderSix,setLoaderSix] = useState(false);
	 const [loaderSeven,setLoaderSeven] = useState(false);
	 const [loaderEight,setLoaderEight] = useState(false);
	 const [loaderNine,setLoaderNine] = useState(false);
	 const [loaderTen,setLoaderTen] = useState(false);
	 const [addNewLoader,setAddNewLoader] = useState(false)
	 const [loader,setLoader] = useState(true);
	 const [showTooltip, setShowTooltip] = useState(false);
	 const history = useHistory();


	const [warningModal,setWarningModal] = useState(false);
	const toggleUpload = () => {
		setUpload(!upload);
		setFileCsv(null);
		setSelectedFile(null);
	}

	const toggleWarning = () => setWarningModal(!warningModal);
	const form = useRef();
	const table = useRef();
	const alert = useRef();
	const contactForm = useRef();
	const brandForm = useRef();
	const cardTypeForm = useRef();
	const contactTable = useRef();
	const brandTable = useRef();
	const cardTypeTable = useRef();
	const brandsSelect = useRef();
	const fundTable = useRef();
	const isMounted = useRef(null);
	const header = [
		{ title: 'Name', data: 'name', sortable: true, searchable: true },
		{ title: 'Main Phone', data: 'mainPhone', sortable: true, searchable: true },
		{ title: 'Website', data: 'website', sortable: true, searchable: true },
		{
			title: 'Status', data: 'active', sortable: true, searchable: true, render: data => {
				if (data)
					return "Active";
				return "Disabled";
			}
		}
	];


	const headerFund = [
		{ title: 'Supplier Name', data: 'supplierName',render:(data)=>{
			if(data){
				return data
			}else{
				return ``
			}
		}},
		{ title: 'Supplier Balance', data: 'Balance', render: (data) => (data === null || data === undefined || data === "") ? '' : data},
		{ title: 'Supplier Threshold', data: 'threshold',render:(data)=>{
			if(data){
				return data
			}else{
				return ``
			}
		}},
		
	]



	function setSuppliers(data) {
		setLoader(false);
		if (table.current && data && data.length > 0) {
			
			table.current.dataTable.clear().rows.add(data).draw();
			table.current.dataTable.search("").draw();
			setsuppliers(data.map(supplier => ({ ...supplier, label: supplier.name, value: supplier.id })))
		}
	}

	function onRowCreated(row) {
		row.classList.add("ncentiva-datatable-row");
		row.addEventListener('click', () => {
			const thisRow = table.current.dataTable.row(row);
			if (thisRow.child.isShown()) {
				thisRow.child.hide();
			} else {
				thisRow.child.show();
			}
		});
	}

	const [supplierId, setSupplierId] = useState('')
	function onChildRow(e, show, row) {
		if (show) {
			const rowData = row.data();
			const addressBlock = document.getElementById(`address-${rowData.id}`);
			const contactsBlock = document.getElementById(`contacts-${rowData.id}`);
			const thresholdBlock = document.getElementById(`payment-${rowData.id}`);
			setSupplierId(rowData.id);
			if (addressBlock.dataset.loaded === "false") {
				supplierCtl.address(rowData.id, data => {
					if (data && !data.error) {
						let country = countries.find(item => item.id === data.countryId)
						if (!country)
							country = { name: "No country information" };
						addressBlock.innerHTML = `Street: ${Utils.deleteTags(data.street)}<br>City: ${Utils.deleteTags(data.city)}<br>Postal Code: ${Utils.deleteTags(data.postalCode)}<br>Country: ${Utils.deleteTags(country.name)}`;
						addressBlock.dataset.loaded = "true";
					} else {
						addressBlock.innerHTML = `Error retrieving data: ${data.error}`;
					}
				});
			}
			if (contactsBlock.dataset.loaded === "false") {
				supplierCtl.contactInfo(rowData.id, data => {
					if (data && !data.error) {
						if (data.length > 0) {
							const primary = data.find(item => item.contactTypeId === 1);
							contactsBlock.innerHTML = `Primary Contact: ${Utils.deleteTags(primary.firstName)} ${Utils.deleteTags(primary.lastName)}<br>email: <a href="mailto:${Utils.deleteTags(primary.email)}">${Utils.deleteTags(primary.email)}</a><br>Phone: ${Utils.deleteTags(primary.phone)}<br>Mobile: ${Utils.deleteTags(primary.mobile)}`;
						} else {
							contactsBlock.innerHTML = "There are no contacts associated with this supplier.";
						}
						contactsBlock.dataset.loaded = "true";
					} else {
						contactsBlock.innerHTML = `Error retrieving data: ${data.error}`;
					}
				});
			}
			if (thresholdBlock.dataset.loaded === "false") {
				supplierCtl.thresholdAmount(rowData.id, data => {
					if (data && !data.error) {
						const paymentType = paymentOptions.find(item => item.id === data.paymentOptionId);
						if (paymentType) {
							thresholdBlock.innerHTML = `Payment type: ${paymentType.name}${paymentType.requiresAmount ? `<br>Threshold Amount: $ ${data.thresholdAmount.toFixed(2)}` : ""}`;
							thresholdBlock.dataset.loaded = "true";
						} else {
							thresholdBlock.innerHTML = "No payment information available";
						}
					} else {
						thresholdBlock.innerHTML = `Error retrieving data: ${data.error}`;
					}
				});
			}
		}
	}

	function onDraw() {
		if (table.current) {
			table.current.dataTable.rows().eq(0).each((i) => {
				const row = table.current.dataTable.row(i);
				const rowData = row.data();
				if (rowData) {
					let child = `<div class="row">
							<div class="col-4" id="address-${rowData.id}" data-loaded="false">Loading info...</div>
							<div class="col-4" id="contacts-${rowData.id}" data-loaded="false">Loading info...</div>
							<div class="col-4" id="payment-${rowData.id}" data-loaded="false">Loading info...</div>
						</div>`;
					row.child(child).hide();
					row.child().addClass("ncentiva-datatable-child-row");
				}
			}
			)
		}
	}

	function onPaymentTypeChange() {
		const ctl = document.getElementById("paymentTypeCtl");
		const savetl = document.getElementById("saveButton");
		if (form.current.paymentTypeId.options[form.current.paymentTypeId.selectedIndex].dataset["requiresAmount"] === "true")
			ctl.style.visibility = "visible";
		else
			ctl.style.visibility = "hidden";

		if(form.current.paymentTypeId.selectedIndex === 1){
			form.current.paymentTypeAmount.value = null
		}
		if(savetl){
			if(form.current.paymentTypeId.selectedIndex === 0){
				savetl.style.visibility ="hidden"
			}else{
				savetl.style.visibility ="visible"
			}
		}
		
	}

	function prepareToAdd() {
		if(accessRoles.includes("ACCOUNTANT_MANAGER") ||  accessRoles.includes("COMMERCIAL_MANAGER") || accessRoles.includes("CUSTOMER_SERVICE")) {
			toggleWarning();
			return;
		  }

		toggle();
		setActiveOp("Add New");
		setIsAddressInfoOpen(true);
		setIsPaymentOptions(true);
		setisFeesandDiscount(true);
		setIsContactInfoOpen(true);
		setIsSupplierBrandInfo(true)
		setActiveOpText("Please provide the information for the supplier you want to add.");
	}

	function prepareToEdit(row) {
		const rowData = row.data()
		setSupplierId(rowData?.id)
		toggle();
		setCallFundApi(prev=>prev+1)
		setActiveOp("Edit");
		setIsAddressInfoOpen(false);
		setIsPaymentOptions(false);
		setisFeesandDiscount(false);
		setIsContactInfoOpen(false);
		setIsSupplierBrandInfo(false)
		setActiveOpText("Edit the information of the supplier.");
		setOperativeRow(row);
		setSupplierName(rowData?.name)
	}

	function cancelOperation(e) {
		e.preventDefault();
		e.stopPropagation();
		// toggle();
		if (activeOp === 'Add New') {
			let hasChanges = false
			form.current.forEach(el => {
				if (!!el.value && el.value !== '-1') {
					hasChanges = true
				}
			})

			if (hasChanges) {
				setShowAlertMessage(true)
			} else {
				setModal(false)
			}

		} else {
			const formHasChanges = modelChange({ ...operativeRow.data(), ...supplierInformation }, form.current)
			if (formHasChanges) {
				setShowAlertMessage(true)
			} else {
				setModal(!modal)
			}
		}
		setIsSupplierAPI(false)
	}

	function finishOperation(e) {
		setAddNewLoader(true)
		e.preventDefault();
		e.stopPropagation();

		let basicInfo = !isSupplierAPI ? [
			{ label: "Supplier Name", property: "name", required: true },
			{ label: "Main Phone", property: "mainPhone", required: true, type: "phone" },
			{ label: "Website", property: "website", required: false, type: "url" },
			{ label: "Active Supplier", property: "active", required: false, type: "check" },
			{ label: "EDT", property: "edt", type: "number" ,defaultValue:0}
		]

			: [
				{ label: "Supplier Name", property: "name", required: true },
				{ label: "Main Phone", property: "mainPhone", required: true, type: "phone" },
				{ label: "Website", property: "website", required: false, type: "url" },
				{ label: "Active Supplier", property: "active", required: false, type: "check" },
				{ label: "EDT", property: "edt", required: true, type: "number" }
			]


		const fv = new FormValidator(form.current, (type, message) => Notify(alert, type, message), basicInfo);

		if (!fv.isFormValid())
			return;

		const av = new FormValidator(form.current, (type, message) => Notify(alert, type, message),
			[
				{ label: "Street and Number", property: "street", required: true },
				{ label: "City", property: "city", required: true },
				{ label: "Postal or Zip Code", property: "postalCode", input: "zipcode", required: true },
				{ label: "Country", property: "countryId", required: true, noVal: "-1" }
			]
		);

		if (!av.isFormValid())
			return;

		const pov = new FormValidator(form.current, (type, message) => Notify(alert, type, message),
			[
				{ label: "Payment Option", property: "paymentOptionId", input: "paymentTypeId", required: true, noVal: "-1" },
				{
					label: "Threshold Amount", property: "thresholdAmount", input: "paymentTypeAmount", required: true,
					ignoreCondition: { input: "paymentTypeId", type: "select", subType: { type: "dataset", property: "requiresAmount" }, value: "false" },
					defaultValue: "0"
				}
			]
		);

		if (!pov.isFormValid())
			return;

		const fdv = new FormValidator(form.current, (type, message) => Notify(alert, type, message),
			[
				{
					label: "Purchase Fee", property: "purchaseFee", required: false, defaultValue: 0,
					conditions: [
						{ op: "gt", value: "-1" }
					]
				},
				{
					label: "Purchase Discount", property: "purchaseDiscount", required: false, defaultValue: 0,
					conditions: [
						{ op: "gt", value: "-1" }
					]
				}
			]
		);

		if (!fdv.isFormValid())
			return;

		const acv = new FormValidator(form.current, (type, message) => Notify(alert, type, message),
			[
				{ label: "Credential Type", property: "authenticationType", input: "credentialTypeId", required: false },
				{
					label: "Client Id", property: "accessKey", input: "clientId", required: true,
					ignoreCondition: { input: "credentialTypeId", type: "select", value: "0", negate: true }
				},
				{
					label: "Secret", property: "secretKey", input: "secretKeyId", required: true,
					ignoreCondition: { input: "credentialTypeId", type: "select", value: "0", negate: true }
				},
				{
					label: "API Key", property: "merchantId", required: true,
					ignoreCondition: { input: "credentialTypeId", type: "select", value: "1", negate: true }
				},
				{
					label: "Secret", property: "merchantId", required: true,
					ignoreCondition: { input: "credentialTypeId", type: "select", value: "1", negate: true }
				},
				{
					label: "User", property: "user", input: "userId", required: true,
					ignoreCondition: { input: "credentialTypeId", type: "select", value: "2", negate: true }
				},
				{
					label: "Password", property: "password", input: "passwordId", required: true,
					ignoreCondition: { input: "credentialTypeId", type: "select", value: "2", negate: true }
				},
			]
		);

		if (!acv.isFormValid())
			return;

		if (!contactTable.current.dataTable.data().toArray().find(item => parseInt(item.contactTypeId) === 1)) {
			Notify(alert, "danger", "The supplier must have at least a Primary Contact");
			return;
		}
		if (!brandTable.current.dataTable.data().length > 0) {
			Notify(alert, "danger", "The supplier must have at least one brand");
			return;
		}
		const supplierData = fv.getDTO();

		switch (activeOp) {
			case "Add New":
				supplierCtl.add(supplierData, data => {
					if(data?.status === 403){
						toggleWarning();
						toggle();
					}
					if (data.errorMessage || data.error) {
						if(data?.error === "Server error response code: 403. Unable to parse response body."){

						}else{
							Notify(alert, "danger", data.errorMessage ?? data.error);
						}
					} else {
						supplierCtl.updateEDT(data.id, supplierData.edt ?? 0, edtData => {
							if (edtData.errorMessage || edtData.error) {
								if(edtData?.error === "Server error response code: 403. Unable to parse response body."){

								}else{
									Notify(alert, "danger", edtData.errorMessage ?? edtData.error);
								}
								// Notify(alert, "danger", edtData.errorMessage ?? edtData.error);
							}
						})
						const addressInfo = av.getDTO();
						addressInfo.supplierId = data.id;

						supplierCtl.addAddress(addressInfo, addressData => {
							if (addressData.errorMessage || addressData.error) {
								if(addressData?.error === "Server error response code: 403. Unable to parse response body."){

								}else{
									Notify(alert, "danger", addressData.errorMessage ?? addressData.error);
								}
								// Notify(alert, "danger", addressData.errorMessage ?? addressData.error);
							} else {
								const paymentInfo = pov.getDTO();
								paymentInfo.supplierId = data.id;

								supplierCtl.addThresholdAmount(paymentInfo, paymentData => {
									if (paymentData.errorMessage || paymentData.error) {
										if(paymentData?.error === "Server error response code: 403. Unable to parse response body."){

										}else{
											Notify(alert, "danger", paymentData.errorMessage ?? paymentData.error);
										}
										// Notify(alert, "danger", paymentData.errorMessage ?? paymentData.error);
									} else {
										const feeInfo = fdv.getDTO();
										feeInfo.supplierId = data.id;

										supplierCtl.addFeeAndDiscount(feeInfo, feeData => {
											if (feeData.errorMessage || feeData.error) {
												if(feeData?.error === "Server error response code: 403. Unable to parse response body."){

												}else{
													Notify(alert, "danger", feeData.errorMessage ?? feeData.error);
												}
												// Notify(alert, "danger", feeData.errorMessage ?? feeData.error);
											} else {
												const apiCredentials = acv.getDTO();
												if (apiCredentials.authenticationType !== "-1") {
													apiCredentials.supplierId = data.id;
													supplierCtl.addApiCredentials(apiCredentials, apiData => {
														
														
														if (apiData.errorMessage || apiData.error) {
															if(apiData?.error === "Server error response code: 403. Unable to parse response body."){

															}else{
																Notify(alert, "danger", apiData.errorMessage ?? apiData.error);
															}
															// Notify(alert, "danger", apiData.errorMessage ?? apiData.error);
														} else {
															
															Notify(alert, "info", "Supplier saved successfully");
															sendContacts(contactTable.current.dataTable.data(), supplierData, data, () => {
																saveLayout(data, () => {
																	Notify(alert, "info", "Supplier saved successfully");
																	toggle();
																})
															});
														}
													});
												} else {
													Notify(alert, "info", "Supplier saved successfully");
													sendContacts(contactTable.current.dataTable.data(), supplierData, data, () => {
														saveLayout(data, () => {
															Notify(alert, "info", "Supplier saved successfully");
															toggle();
														})
													});
												}
											}
										});
									}
								});
							}
						});
					}
				});
				break;
			case "Edit":
				supplierData.id = operativeRow.data().id;
				supplierCtl.update(supplierData, data => {
					if(data?.status === 403){
						toggleWarning();
						toggle();
					}
					if (data.errorMessage || data.error) {
						if(data?.error === "Server error response code: 403. Unable to parse response body."){

						}else{
							Notify(alert, "danger", data.errorMessage ?? data.error);
						}
						// Notify(alert, "danger", data.errorMessage ?? data.error);
					} else {
						supplierCtl.updateEDT(data.id, supplierData.edt ?? 0, edtData => {
							if (edtData.errorMessage || edtData.error) {
								if(edtData?.error === "Server error response code: 403. Unable to parse response body."){

								}else{
									Notify(alert, "danger", edtData.errorMessage ?? edtData.error);
								}
								// Notify(alert, "danger", edtData.errorMessage ?? edtData.error);
							}
						})
						const addressInfo = av.getDTO();
						addressInfo.supplierId = data.id;
						supplierCtl.updateAddress(addressInfo, addressData => {
							if (addressData.errorMessage || addressData.error) {
								if(addressData?.error === "Server error response code: 403. Unable to parse response body."){

								}else{
									Notify(alert, "danger", addressData.errorMessage ?? addressData.error);
								}
								// Notify(alert, "danger", addressData.errorMessage ?? addressData.error);
							} else {
								const paymentInfo = pov.getDTO();
								paymentInfo.supplierId = data.id;

								supplierCtl.updateThresholdAmount(paymentInfo, paymentData => {
									if (paymentData.errorMessage || paymentData.error) {
										if(paymentData?.error === "Server error response code: 403. Unable to parse response body."){

										}else{
											Notify(alert, "danger", paymentData.errorMessage ?? paymentData.error);
										}
										// Notify(alert, "danger", paymentData.errorMessage ?? paymentData.error);
									} else {
										const feeInfo = fdv.getDTO();
										feeInfo.supplierId = data.id;

										supplierCtl.updateFeeAndDiscount(feeInfo, feeData => {
											if (feeData.errorMessage || feeData.error) {
												if(feeData?.error === "Server error response code: 403. Unable to parse response body."){

												}else{
													Notify(alert, "danger", feeData.errorMessage ?? feeData.error);
												}
												// Notify(alert, "danger", feeData.errorMessage ?? feeData.error);
											} else {
												Notify(alert, "info", "Supplier saved successfully");
												Notify(alert, "info", "Supplier saved successfully");
												sendContacts(contactTable.current.dataTable.data(), supplierData, data, () => {
													saveLayout(data, () => {
														Notify(alert, "info", "Supplier saved successfully");
														toggle();
													})
												});
											}
										});
									}
								});
							}
						});
					}
				});
				break;
			default:
		}
	}


	useEffect(()=>{
		if(supplierId){
			supplierCtl.getFundDetails(supplierId,(data)=>{
				if(data && !data?.error){
					setFundDetailsData(data)
				    setSupplierBalance(data?.supplierBalance)
					setThrsholdValue(data?.thresholdAmount)
					}else{
					}
				})}
 
	},[supplierId,callFundApi])


	useEffect(() => {
		setFundTableData({
			id:fundDetailsData?.id,
			supplierName: fundDetailsData?.supplierName,
			threshold: fundDetailsData?.thresholdAmount,
			Balance: fundDetailsData?.supplierBalance,
			});
	}, [fundDetailsData]);
	

	useEffect(() => {
		if(fundTable.current){
	  fundTable.current.dataTable.clear().row.add(fundTableData).draw();
	 } 
	 
	  },[fundTableData])
	  
	function sendContacts(contacts, supplierData, data, done) {
		let iter = 0;
		if (contacts[iter]) {
			const saveContact = () => {
				contacts[iter].supplierId = data.id;
				let op;

				switch (contacts[iter].status) {
					case "new":
						op = supplierCtl.addContactInfo.bind(supplierCtl);
						break;
					case "edit":
						op = supplierCtl.updateContactInfo.bind(supplierCtl);
						break;
					default:
						op = (data, cb) => cb(data);
				}



				op(contacts[iter], contactData => {
					if (contactData.errorMessage || contactData.error) {
						if(contactData?.error === "Server error response code: 403. Unable to parse response body."){

						}else{
							Notify(alert, "danger", contactData.errorMessage ?? contactData.error);
						}
						// Notify(alert, "danger", contactData.errorMessage ?? contactData.error);
					} else {
						contacts[iter].contactId = contactData.contactId;
						if (contacts[++iter])
							saveContact();
						else {
							sendBrands(brandTable.current.dataTable.data().toArray(), data, () => {
								if (operativeRow) {
									operativeRow.data(data).draw();
									setOperativeRow(null);
								} else {
									table.current.dataTable.row.add(data).draw();
								}
								done();
							});
						}
					}
				})
			};
			saveContact();
		} else {
			sendBrands(brandTable.current.dataTable.data().toArray(), data, () => {
				if (operativeRow) {
					operativeRow.data(data).draw();
				} else {
					table.current.dataTable.row.add(data).draw();
				}
				done();
			});
		}
	}

	const saveSendContact = (contacts,data,) =>{
		setLoaderSix(true)
		let iter = 0;
		if (contacts[iter]) {
			const saveContact = () => {
				contacts[iter].supplierId = data.id;
				let op;

				switch (contacts[iter].status) {
					case "new":
						op = supplierCtl.addContactInfo.bind(supplierCtl);
						break;
					case "edit":
						op = supplierCtl.updateContactInfo.bind(supplierCtl);
						break;
					default:
						op = (data, cb) => cb(data);
				}



				op(contacts[iter], contactData => {
					if (contactData.errorMessage || contactData.error) {
						if(contactData?.error === "Server error response code: 403. Unable to parse response body."){
						contactLoader();
						}else{
							Notify(alert, "danger", contactData.errorMessage ?? contactData.error);
							contactLoader();
						}
						// Notify(alert, "danger", contactData.errorMessage ?? contactData.error);
					} else {
						contacts[iter].contactId = contactData.contactId;
						if (contacts[++iter])
							saveContact();
						else {
							Notify(alert,"success","Contact saved successfully")
							// done();
							contactLoader()
						}
					}
				})
			};
			saveContact();
		} else {
		contactLoader();
			// done();
		}
	}

	function sendBrands(brands, supplierData, done) {
		
		let brandIter = 0;
		if (brands[brandIter]) {
			const saveBrand = () => {
				brands[brandIter].supplierId = supplierData.id;
				let op;

				switch (brands[brandIter]?.cards[0]?.status) {
					case "new":
						op = supplierCtl.addBrand.bind(supplierCtl);
						break;
					case "edit":
						op = supplierCtl.updateBrand.bind(supplierCtl);
						break;
					default:
						op = (data, cb) => cb(data);
				}

				op(brands[brandIter], brandData => {
					if (brandData.errorMessage || brandData.error) {
						if(brandData?.error === "Server error response code: 403. Unable to parse response body."){
							setLoader(false);

						}else{
							Notify(alert, "danger", brandData.errorMessage ?? brandData.error);
							setLoader(false);
						}
						// Notify(alert, "danger", brandData.errorMessage ?? brandData.error);
					} else {
						setLoader(false);
                      const cardsToSend = brands[brandIter].cards;
					  brands[brandIter].id = brandData.id;
						sendCardTypes(brandData, supplierData, cardsToSend, () => {
							if (brands[++brandIter]){
								
							}
								// saveBrand();
							else
								done();
						}, brands[brandIter].id);
					}
				})
			};
			saveBrand();
		} else {
			done();
		}
	}

	function sendCardTypes(brandData, supplierData, cardsToSend, done, mappedItemId = null) {
		let cardIter = 0;
		if (cardsToSend[cardIter]) {
			const saveCard = () => {
				cardsToSend[cardIter].supplierId = supplierData.id;
				cardsToSend[cardIter].supplierBrandId = brandData.id;
				let op;
				switch (cardsToSend[cardIter].status) {
					case "new":
						op = supplierCtl.addCard.bind(supplierCtl);
						break;
					// case "edit":
					// 	op = supplierCtl.updateCard.bind(supplierCtl);
					// 	break;
					default:
						op = (data, cb) => cb(data);
				}

				let card = cardsToSend[cardIter]
				let supplierItem = cardsToSend[cardIter].supplierItem;
				if (supplierItem?.sku) {
					supplierCtl.supplierItem(supplierItem.sku, supplierData.id, supplierItemData => {
						if (supplierItemData.errorMessage || supplierItemData.error) {
							// if(supplierItemData?.error === "Server error response code: 403. Unable to parse response body."){
                            //   }
							//   else{
								// Notify(alert, "danger", supplierItemData.errorMessage);
							//   }
							supplierCtl.addCardtoCatalog({ ...supplierItem, supplierId: supplierData.id }, catalogData => {
								if (catalogData.errorMessage || catalogData.error) {
									if(catalogData?.error === "Server error response code: 403. Unable to parse response body."){

									}else{
										Notify(alert, "danger", catalogData.errorMessage ?? catalogData.error);
									}
									// Notify(alert, 'danger', catalogData.errorMessage ?? catalogData.error)
									if (cardsToSend[++cardIter])
										saveCard();
									else
										done();
								} else {
									op(card, cardData => {
										if (cardData.errorMessage || cardData.error) {
											Notify(alert, 'danger', cardData.errorMessage ?? cardData.error)
											if (cardsToSend[++cardIter])
												saveCard();
											else
												done();
										} else {

											if (!cardTypeTableInformation.find(cardType => cardType.id === card.id)) {
												skuMappingCtl.add({
													giftCardTypeId: cardData.giftCardTypeId,
													supplierGiftCardCatalogId: catalogData.id
												}, mappingData => {
													if (mappingData.errorMessage || mappingData.error) {
														Notify(alert, 'danger', mappingData.errorMessage ?? mappingData.error)
													}else{
													toggle();
													}
												})
											}

										}
									})
								}
							})
						} else {
							op(card, cardData => {
								if (cardData.errorMessage || cardData.error) {
									Notify(alert, 'danger', cardData.errorMessage ?? cardData.error)
									if (cardsToSend[++cardIter])
										saveCard();
									else
										done();
								} else {

									if (!cardTypeTableInformation.find(cardType => cardType.id === card.id)) {
										skuMappingCtl.add({
											giftCardTypeId: cardData.giftCardTypeId,
											supplierGiftCardCatalogId: supplierItemData.id
										}, mappingData => {
											if (mappingData.errorMessage || mappingData.error) {
												Notify(alert, 'danger', mappingData.errorMessage ?? mappingData.error)
											}else{
											toggle();
											}
										})
									}

								}
							})
						}
					});
				}

				if (cardsToSend[++cardIter])
					saveCard();
				else
					done();
			};
			saveCard();
		} else {
			done();
		}
	}

	function saveLayout(supplierData, done) {
		setLoaderTen(true)
		if (bulkLayout !== null) {
			const layout = {
				fields: [
					{
						"sourceIndex": bulkLayout.brand === "notAvailable" ? 0 : bulkLayout.brand,
						"sourceName": "",
						"targetColumn": "BRAND",
						"value": 0
					},
					{
						"sourceIndex": bulkLayout.cardType === "notAvailable" ? 0 : bulkLayout.cardType,
						"sourceName": "",
						"targetColumn": "CARD_TYPE",
						"value": 0
					},
					{
						"sourceIndex": bulkLayout.expirationDate === "notAvailable" ? 0 : bulkLayout.expirationDate,
						"sourceName": "",
						"targetColumn": "EXPIRATION_DATE",
						"value": 0
					},
					{
						"sourceIndex": bulkLayout.data.code === "notAvailable" ? 0 : bulkLayout.data.code,
						"sourceName": "",
						"targetColumn": "CODE",
						"value": 0
					},
					{
						"sourceIndex": bulkLayout.data.activationCode === "notAvailable" ? 0 : bulkLayout.data.activationCode,
						"sourceName": "",
						"targetColumn": "ACTIVATION_CODE",
						"value": 0
					},
					{
						"sourceIndex": bulkLayout.data.PIN === "notAvailable" ? 0 : bulkLayout.data.PIN,
						"sourceName": "",
						"targetColumn": "PIN",
						"value": 0
					}
				],
				headerPresent: true,
				mappingType: "FILE_WITH_ALL_BRANDS_AND_CARD_TYPES",
				name: "",
				supplierId: supplierData.id
			};

			supplierCtl.addLayout(layout, layoutData => {
				if (layoutData.errorMessage || layoutData.error) {
					Notify(alert, "danger", layoutData.errorMessage ?? layoutData.error);
					bulkUpload()
				} else {
					// done();
					bulkUpload()
					Notify(alert,"success","Supplier file upload successfully")
				}
			})
		} else {
			// done();
			bulkUpload();
			
		}
	}

	function removeSupplier(row) {
		Notify(alert, "warning", "Deletion of suppliers is disabled");
	}

	function confirmDelete() {
		toggleConfirm();
	}

	const prepareForm = () => {
		if (form.current) {
			form.current.reset();
			setBulkLayout(null);

			Utils.FillDropdown(form.current.countryId, countries);
			Utils.FillDropdown(form.current.paymentTypeId, paymentOptions, ["requiresAmount"]);
			onPaymentTypeChange();
			form.current.purchaseFee.value = 0;
			form.current.purchaseDiscount.value = 0;

			form.current.active.checked = true;
			if (activeOp === "Edit" && !!operativeRow.data) {
				const rowData = operativeRow.data();
				form.current.supplierId.value = rowData.id;
				form.current.name.value = rowData.name;
				form.current.mainPhone.value = rowData.mainPhone;
				form.current.website.value = rowData.website;
				form.current.active.checked = rowData.active;

				supplierCtl.byId(rowData.id, data => {
					if (data.errorMessage || data.error) {
						Notify(alert, "danger", data.errorMessage ?? data.error);
					} else {
						data.edt = data.etd
						if (data.etd > 0) {
							form.current.supplierType.checked = true;
							setIsSupplierAPI(past => true)
							form.current.edt.value = data.edt
						}
					}
				})

				supplierCtl.address(rowData.id, data => {
					if (data.errorMessage || data.error) {
						Notify(alert, "danger", data.errorMessage ?? data.error);
					} else {
						setSupplierInformation(prevSupplierInformation => ({ ...prevSupplierInformation, ...data }))
						form.current.street.value = data.street;
						form.current.city.value = data.city;
						form.current.zipcode.value = data.postalCode;
						form.current.countryId.value = data.countryId;
					}
				});

				supplierCtl.thresholdAmount(rowData.id, data => {
					if (data.errorMessage || data.error) {
						Notify(alert, "danger", data.errorMessage ?? data.error);
					} else {
						setSupplierInformation(prevSupplierInformation => ({ ...prevSupplierInformation, ...data }))
						form.current.paymentTypeId.value = data.paymentOptionId.toString();
						form.current.paymentTypeAmount.value = data.thresholdAmount;
						onPaymentTypeChange();
					}
				});

				supplierCtl.feesAndDiscount(rowData.id, data => {
					if (data.errorMessage || data.error) {
						Notify(alert, "danger", data.errorMessage ?? data.error);
					} else {
						setSupplierInformation(prevSupplierInformation => ({ ...prevSupplierInformation, ...data }))
						form.current.purchaseFee.value = data.purchaseFee;
						form.current.purchaseDiscount.value = data.purchaseDiscount;
					}
				});

				supplierCtl.contactInfo(rowData.id, data => {
					if (data.errorMessage || data.error) {
						Notify(alert, "danger", data.errorMessage ?? data.error);
					} else {
						setSupplierInformation(prevSupplierInformation => ({ ...prevSupplierInformation, ...data }))
						contactTable.current.dataTable.rows.add(data).draw();
					}
				});

				supplierCtl.cardCatalogBySupplier(rowData.id, catalogData => {
					if (catalogData.errorMessage || catalogData.error) {
						setSupplierCardCatalog([]);
					} else {
						setSupplierCardCatalog(catalogData);
					}
				})

				skuMappingCtl.mappingsBySupplier(rowData.id, mappingData => {
					if (mappingData.error || mappingData.errorMessage) {
						setMappings([]);
					} else {
						setMappings(mappingData);
					}
				});
				// brandTable.current = $('#example').DataTable();
				isMounted.current = true;
				
				
				supplierCtl.brands(rowData.id, async data => {
					if ((data.errorMessage || data.error) && data.errorCode === "NOT_FOUND") {
						Notify(alert, "danger", data.errorMessage ?? data.error);
					} else {
						const brandPromises = data?.map(item => {
							return new Promise(resolve => {
								supplierCtl.cardsByBrandBySupplier(item.supplierId, item.id, cardData => {
									if ((cardData.errorMessage || cardData.error) && cardData.errorCode !== "NOT_FOUND") {
										Notify(alert, "danger", cardData.errorMessage ?? cardData.error);
										resolve(null); // Handle the error case
									} else {
										if (cardData.errorCode !== "NOT_FOUND") {
											item.cards = cardData.map(card => ({ ...card, status: 'edit' }));
										} else {
											item.cards = [];
										}
										resolve(item); // Resolve with the updated item
									}
								});
							});
						});
				
						const resolvedBrands = await Promise.all(brandPromises);
				
						// Filter out null values (failed responses) and update the table
						resolvedBrands
							.filter(item => item !== null)
							.forEach(validItem => brandTable.current.addRow(validItem));
					}
				});
				
				return () =>
					{
					isMounted.current = false
					if (brandTable.current) {
						brandTable.current.destroy();
					  }
					};
			}
		}
	}

	function prepareContactForm() {
		if (!contactForm.current)
			return;
		Utils.FillDropdown(contactForm.current.contactTypeId, contactTypes);
		if (activeContact) {
			const d = activeContact.data();
			contactForm.current.contactTypeId.value = d.contactTypeId.toString();
			contactForm.current.contactFirstName.value = d.firstName;
			contactForm.current.contactLastName.value = d.lastName;
			contactForm.current.contactPhone.value = d.phone;
			contactForm.current.contactMobile.value = d.mobile;
			contactForm.current.contactEmail.value = d.email;
			contactForm.current.contactId.value = d.contactId;
		}
	}

	function addContact() {
		if (!contactForm.current) return;

		const cv = new FormValidator(contactForm.current, (type, message) => Notify(alert, type, message),
			[
				{ label: "", property: "contactId", required: false },
				{ label: "Contact Type", property: "contactTypeId", input: "contactTypeId", required: true, noVal: "-1" },
				{ label: "First Name", property: "firstName", input: "contactFirstName", required: true },
				{ label: "Last Name", property: "lastName", input: "contactLastName", required: true },
				{ label: "Phone", property: "phone", input: "contactPhone", required: true, type: "phone" },
				{ label: "Mobile", property: "mobile", input: "contactMobile", required: false, type: "phone" },
				{ label: "Email", property: "email", input: "contactEmail", required: true, type: "email" }
			]
		);

		if (!cv.isFormValid())
			return;

		const newContact = cv.getDTO();
		Notify(alert, "info", "Contact saved successfully");
		if (activeContact) {
			newContact.status = "edit";
			activeContact.data(newContact).draw();
			setContactModal(false);
			
		} else {
			newContact.status = "new";
			contactTable.current.dataTable.row.add(newContact).draw();
			contactForm.current.reset();
			setContactModal(false);
			
		}
	}

	useEffect(() => {
		if (activeBrand) {
			const data = activeBrand.data()
			setCardTypeTableInformation(() => data.cards.map(card => {
				if (card.status === 'new') {
					return card
				}
				const cardType = cardTypes.find(cardType => parseInt(cardType.id) === card.giftCardTypeId)
				const mapping = mappings.find(mapping => cardType.id === mapping.giftCardTypeId)
				const supplierCard = !!mapping ? supplierCardCatalog.find(card => card.id === mapping.supplierGiftCardCatalogId) : { productName: 'Not mapped' }

				return {
					...card,
					productName: cardType.productName,
					sku: cardType.sku,
					supplierItem: supplierCard,
					mappedItemId: mapping ? mapping.id : null
				}
			}))
		}
	}, [activeBrand])

	const handleSupplierName = (e)=>{
		const value = e.target.value
      setSupplierName(value)
	}
const handleThrsholdValue = (e) =>{
	const value = e.target.value;
	setThrsholdValue(value)
}
const handleSupplierBalace = (e) =>{
	const value = e.target.value
	setSupplierBalance(value)
}

	function prepareBrandForm() {
		if (!brandForm.current)
			return;
		let savedBrands = brandTable.current.dataTable.data().toArray();
		if (activeBrand) {
			setBrandOperation('Edit')
			const d = activeBrand.data();
			setBrandFilter(
				[...brands.filter(brand =>
					!savedBrands.map(savedBrand => savedBrand.brandId).includes(brand.id)
				), d.brand]
			);
			setSelectedOption({ label: d.brand.name, value: d.brand.id })

			brandForm.current.approvalRequired.checked = d.approvalRequired;
			brandForm.current.brandLimitMinAmount.value = d.minimumAmount === 0 ? "" : d.minimumAmount;
			brandForm.current.brandLimitMaxAmount.value = d.maximumAmount === 0 ? "" : d.maximumAmount;
			brandForm.current.brandLimitMinQuantity.value = d.minimumQuantity === 0 ? "" : d.minimumQuantity;
			brandForm.current.brandLimitMaxQuantity.value = d.maximumQuantity === 0 ? "" : d.maximumQuantity;
			brandForm.current.brandTimeThreshold.value = d.timeThreshold;
			brandForm.current.brandDiscount.value = d.purchaseDiscount ?? "";
			brandForm.current.brandFee.value = d.purchaseFee ?? "";
			cardTypeTable.current.dataTable.rows.add(
				d.cards.map(card => {
					if (card.status === 'new') {
						return card
					}
					let cardType = cardTypes.find(cardType => parseInt(cardType.id) === card.giftCardTypeId)
					let mapping = mappings.find(mapping => cardType.id === mapping.giftCardTypeId)
					let supplierCard = !!mapping ? supplierCardCatalog.find(card => card.id === mapping.supplierGiftCardCatalogId) : { productName: 'Not mapped' }
					return {
						...card,
						productName: cardType.productName,
						sku: cardType.sku,
						supplierItem: supplierCard,
						mappedItemId: mapping ? mapping.id : null
					}
				})
			).draw();

		} else {
			setBrandOperation('New')
			setBrandFilter(
				brands.filter(brand =>
					!savedBrands.map(savedBrand => savedBrand.brandId).includes(brand.id)
				)
			);
		}
	}

	function addBrand() {
		if (!brandForm.current) return;
		let properties;
		if (extraBrandInfo) {
			properties = [
				{ label: "Active", property: "active", required: false, defaultValue: true },
				{ label: "Approval Required", property: "approvalRequired", required: false, type: "check" },
				{ label: "Currency", property: "currency",input:"currencyName",required: false, },
				{
					label: "Minimum Amount", property: "minimumAmount", input: "brandLimitMinAmount", required: false, defaultValue: 0,
					conditions: [
						{ op: 'gt', value: 0 }
					]
				},
				{
					label: "Maximum Amount", property: "maximumAmount", input: "brandLimitMaxAmount", required: false, defaultValue: 0,
					conditions: [
						{ op: 'gt', value: 0 }
					]
				},
				{
					label: "Minimum Quantity", property: "minimumQuantity", input: "brandLimitMinQuantity", required: false, defaultValue: 0,
					conditions: [
						{ op: 'gt', value: 0 }
					]
				},
				{
					label: "Maximum Quantity", property: "maximumQuantity", input: "brandLimitMaxQuantity", required: false, defaultValue: 0,
					conditions: [
						{ op: 'gt', value: 0 }
					]
				},
				{ label: "Time period", property: "timeThreshold", input: "brandTimeThreshold", required: false, defaultValue: "" },
				{
					label: "Brand Discount", property: "purchaseDiscount", input: "brandDiscount", required: false, defaultValue: 0,
					conditions: [
						{ op: 'gt', value: -1 }
					]
				},
				{
					label: "Brand Fee", property: "purchaseFee", input: "brandFee", required: false, defaultValue: 0,
					conditions: [
						{ op: 'gt', value: -1 }
					]
				}
			]

			const formValue = (input) => {
				return parseInt(brandForm.current[`brandLimit${input}`].value)
			}

			if (formValue('MinAmount') > formValue('MaxAmount')) {
				Notify(alert, 'danger', 'Minimum Amount Should be less than Maximum Amount')
				return
			}
			if (formValue('MinQuantity') > formValue('MaxQuantity')) {
				Notify(alert, 'danger', 'Minimum Quantity Should be less than Maximum Quantity')
				return
			}
		} else {
			properties = [
				{ label: "Active", property: "active", required: false, defaultValue: true },
				{ label: "Approval Required", property: "approvalRequired", required: false, type: "check" },
				{ label: "Currency", property: "currency", input:"currencyName", required: false,},
				{ label: "Minimum Amount", property: "minimumAmount", input: "brandLimitMinAmount", required: false, defaultValue: 1 },
				{ label: "Maximum Amount", property: "maximumAmount", input: "brandLimitMaxAmount", required: false, defaultValue: 1 },
				{ label: "Minimum Quantity", property: "minimumQuantity", input: "brandLimitMinQuantity", required: false, defaultValue: 1 },
				{ label: "Maximum Quantity", property: "maximumQuantity", input: "brandLimitMaxQuantity", required: false, defaultValue: 1 },
				{ label: "Time period", property: "timeThreshold", input: "brandTimeThreshold", required: false, defaultValue: "" },
				{ label: "Brand Discount", property: "purchaseDiscount", input: "brandDiscount", required: false, defaultValue: 0 },
				{ label: "Brand Fee", property: "purchaseFee", input: "brandFee", required: false, defaultValue: 0 }
			]
		}

		const bv = new FormValidator(brandForm.current, (type, message) => Notify(alert, type, message), properties);

		if (!bv.isFormValid())
			return;

		if (!brandsSelect.current.getValue().length > 0) {
			Notify(alert, 'danger', 'Please select a brand')
			return;
		}

		const newBrand = bv.getDTO();
		newBrand.brandId = brandsSelect.current.getValue()[0].value;
		newBrand.brand = brands.find(brand => brand.id === newBrand.brandId)
		newBrand.cards = cardTypeTable.current.dataTable.data().toArray();
		if (!newBrand.cards || newBrand.cards.length === 0) {
			Notify(alert, "danger", "You must add card types to this brand");
			return;
		}
		Notify(alert, "info", "Brand saved successfully");
		if (activeBrand) {
			newBrand.id = activeBrand.data().id
			newBrand.status = "edit";
			activeBrand.data(newBrand).draw();
			setActiveBrand(null)
			setBrandModal(false);
		} else {
			newBrand.status = "new";
			brandTable.current.addRow(newBrand);
			brandForm.current.reset();
			cardTypeTable.current.dataTable.clear().draw();
			setBrandModal(false);
		}
		setLatestAddedBrand(newBrand);
	}

	function addCardType() {
		if (!cardTypeForm.current) return;

		const isShowing = cardTypeForm.current.style.display !== "none";
		if (!isShowing) {
			cardTypeForm.current.style.display = "block";
		} else {
			let properties

			if (extraCardTypeInfo) {
				properties = [
					{ label: "Active", property: "active", required: false, defaultValue: true },
					{ label: "Gift card type", property: "giftCardTypeId", input: "cardTypeId", required: true, noVal: "-1" },
					{
						label: "Minimum Amount", property: "minimumAmount", input: "gctLimitMinAmount", required: false, defaultValue: 0,
						conditions: [
							{ op: 'gt', value: 0 }
						]
					},
					{
						label: "Maximum Amount", property: "maximumAmount", input: "gctLimitMaxAmount", required: false, defaultValue: 1,
						conditions: [
							{ op: 'gt', value: 0 }
						]
					},
					{
						label: "Minimum Quantity", property: "minimumQuantity", input: "gctLimitMinQuantity", required: false, defaultValue: 0,
						conditions: [
							{ op: 'gt', value: 0 }
						]
					},
					{
						label: "Maximum Quantity", property: "maximumQuantity", input: "gctLimitMaxQuantity", required: false, defaultValue: 1,
						conditions: [
							{ op: 'gt', value: 0 }
						]
					},
					{ label: "Time period", property: "timeThreshold", input: "gctTimeThreshold", required: false, defaultValue: "" },
					{
						label: "Brand Discount", property: "purchaseDiscount", input: "gctDiscount", required: false, defaultValue: 0,
						conditions: [
							{ op: 'gt', value: -1 }
						]
					},
					{
						label: "Brand Fee", property: "purchaseFee", input: "gctFee", required: false, defaultValue: 0,
						conditions: [
							{ op: 'gt', value: -1 }
						]
					}
				]

				if (brandForm.current.gctLimitMinAmount.value > brandForm.current.gctLimitMaxAmount.value) {
					Notify(alert, 'danger', 'Minimum Amount Should be less than Maximum Amount')
					return
				}

				if (brandForm.current.gctLimitMinQuantity.value > brandForm.current.gctLimitMaxQuantity.value) {
					Notify(alert, 'danger', 'Minimum Quantity Should be less than Maximum Quantity')
					return
				}
			} else {
				properties = [
					{ label: "Active", property: "active", required: false, defaultValue: true },
					{ label: "Gift card type", property: "giftCardTypeId", input: "cardTypeId", required: true, noVal: "-1" },
					{ label: "Minimum Amount", property: "minimumAmount", input: "gctLimitMinAmount", required: false, defaultValue: 0 },
					{ label: "Maximum Amount", property: "maximumAmount", input: "gctLimitMaxAmount", required: false, defaultValue: 1 },
					{ label: "Minimum Quantity", property: "minimumQuantity", input: "gctLimitMinQuantity", required: false, defaultValue: 0 },
					{ label: "Maximum Quantity", property: "maximumQuantity", input: "gctLimitMaxQuantity", required: false, defaultValue: 1 },
					{ label: "Time period", property: "timeThreshold", input: "gctTimeThreshold", required: false, defaultValue: "" },
					{ label: "Brand Discount", property: "purchaseDiscount", input: "gctDiscount", required: false, defaultValue: 0 },
					{ label: "Brand Fee", property: "purchaseFee", input: "gctFee", required: false, defaultValue: 0 }
				]
			}

			const ctv = new FormValidator(brandForm.current, (type, message) => Notify(alert, type, message), properties);

			if (!brandsSelect.current.getValue().length > 0) {
				Notify(alert, 'danger', 'Brand field is missing')
			}

			if (!ctv.isFormValid())
				return;

			// let sctvProperties;
			// sctvProperties = [
				// { label: "Country", property: "countryId", input: "sctCountryId", required: false, noVal: "-1" },
				// { label: "Currency", property: "currencyId", input: "sctCurrencyId", required: false, noVal: "-1" },
				// {
				// 	label: "Amount", property: "amount", input: "sctAmount", required: false, defaultValue: 0,
					
				// },
				// {
				// 	label: "Minimum Amount", property: "minAmount", input: "sctLimitMinAmount", required: false, defaultValue: 0,
					
				// },
				// {
				// 	label: "Maximum Amount", property: "maxAmount", input: "sctLimitMaxAmount", required: false, defaultValue: 0,
					
				// },
				// { label: "Product Name", property: "productName", input: "sctProductName", required: false, defaultValue: "" },
				// { label: "SKU", property: "sku", input: "sctSKU", required: true, defaultValue: "" },
			// ]

			// let sctvProperties=[{label: "SKU", "SKU"]
			const sctvProperties = new FormValidator(
				brandForm.current,
				(type,message) => Notify(alert,type,message),
				[
				  {
					label: "SKU",
					property: "sku",
					input: "sctSKU",
					required: true,
					defaultValue: ""
				  },
				]
			  )
			// const sctv = new FormValidator(brandForm.current, (type, message) => Notify(alert, type, message), sctvProperties);
			
			// if (!sctvProperties.isFormValid())
			// 	return;
			const sctv=sctvProperties.getDTO()
			let giftcardType ={
				currencyId:currencyId,
				maxAmount:maximumAmount,
				minAmount:minimumAmount,
				productName:productName,
				amount:amount,
			}

			// const merged=Object.assign({...sctv,...giftcardType}
				Object.assign(sctv, giftcardType);
			const newCardType = ctv.getDTO();
			const supplierItem = supplierCardCatalog.find(card => card.sku === brandForm.current.sctSKU.value) ?? sctv;
			if (isVariable) {
				if (supplierItem.minAmount > supplierItem.maxAmount) {
					Notify(alert, 'danger', 'Minimum Amount Should be less than Maximum Amount')
					return;
				}
			}
			const selIdx = brandForm.current.cardTypeId.selectedIndex;
			let cardType = cardTypes?.find(card => card.id === parseInt(newCardType.giftCardTypeId));
			newCardType.supplierItem = supplierItem;
			newCardType.productName = cardType.productName;
			newCardType.sku = cardType.sku;
			// newCardType.tsatus = "new";
			newCardType.status = "new";

			cardTypeTable.current.dataTable.row.add(newCardType).draw();
			setDisableSelect(true)
			brandForm.current.cardTypeId.remove(selIdx);
			cardTypeForm.current.style.display = "none";

			// brandForm.current.sctCountryId.value = "-1";
			brandForm.current.sctCurrencyId.value = "-1";
			brandForm.current.sctAmount.value = "";
			brandForm.current.sctLimitMinAmount.value = "";
			brandForm.current.sctLimitMaxAmount.value = "";
			brandForm.current.sctProductName.value = "";
			brandForm.current.sctSKU.value = "";
		}
	}

	function goToDashboard(row) {
		document.location.href = `/admin/supply/dashboard/${row.data().id}`;
	}
	
	const modelChange = (initial, endModel) => {
		let changed = false
		Object.entries(initial).forEach(([key, value]) => {
			if (endModel[mapKeys[key]] && value !== endModel[mapKeys[key]].value) {
				changed = true
				return
			}
		})
		return changed
	}

	const leaveAllModal = () => {
		setShowAlertMessage(false)
		setModal(false)
		setThrsholdValue("")
	}



	useEffect(() => {
		supplierCtl.all(setSuppliers);
		cardTypeCtl.all(data => setCardTypes(data));
	}, [cardTypeCtl, supplierCtl]);


	const onDeleteSuplierBrand = () => {
		purchaseOrderCtl.deleteSupplierBrand(deleteFlag.data().id, (data) => {
			if (data && !data.error) {
				setDeleteFlag({});
				if (brandTable.current) {
					setShowAlertMessage(false)
					deleteFlag.remove().draw();


				}
			} else {
				leaveAllModal();
				setDeleteFlag({});
				Notify(alert, 'danger', data.error);
			}
		});
	}
	const [selectedFile, setSelectedFile] = useState(null);
	const fileInputRef = useRef(null);
	const handleFileChange = (event) => {
		setSelectedFile(event.target.files[0]);
		setFileCsv(event.target.files[0]);
	  };
	const downloadFile = (data, filename) => {
		const csvData = convertToCSV(data);
		const url = window.URL.createObjectURL(new Blob([csvData]));
		const link = document.createElement("a");
		link.href = url;
		link.setAttribute("download", filename);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	  };

	  const downloadCSVFile = (csvData, fileName = 'data.csv') => {
		const blob = new Blob([csvData],);;
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = fileName;
		document.body.appendChild(a);
		a.click();
		window.URL.revokeObjectURL(url);
	}
	
	  const convertToCSV = (data) => {
		const header = Object.keys(data[0]).join(",");
		const rows = data.map((obj) => Object.values(obj).join(","));
		return `${header}\n${rows.join("\n")}`;
	  };
	
	  const downloadBrandLimit = async () => {
		const rowData = operativeRow.data();
		const id = rowData.id;
		await supplierCtl.downloadSupplierBrand(id, (dat) => {
		  if (dat && !dat.error) {
			const name = rowData.name;
			downloadFile(dat, `${name}-${id}.csv`);
			Notify(alert, "success", "File Succesfully Download");
		  }else{
			Notify(alert, "danger", dat.error);
		  }
		});
		
	  };


	const downloadCsv = async () => {
		setLoaderSeven(true)
		const rowData = operativeRow.data();
		const id = rowData.id;
		await supplierCtl.download(id, (data) => {
			if (typeof data === 'string') {
				catalogLoader();
				const name = rowData.name;
				downloadCSVFile(data, `${name}-${id}.csv`);
				Notify(alert, "success", "File Successfully Downloaded");
			} else {
				if (data && data.error) {
					Notify(alert, "danger", data.error);
					catalogLoader();
				} else {
					Notify(alert, "warning", "Unexpected response format");
					catalogLoader();
				}
			}
		});
	};
	

	const handleFileUpload = async (event) => {
		setLoaderEight(true)
		event.preventDefault();
		const rowData = operativeRow.data();
		const id = rowData.id;
		const formData = new FormData();
		formData.append("file", selectedFile);
		if (selectedFile === null) {
			Notify(alert, "danger", "please upload a file");
			uploadLoader();
			return false;
		  } 
		  
		const datas = await supplierCtl.uploadSupplierBrand(id, formData, (res) => {
		  if (res === undefined) {
			Notify(alert, "danger", "please upload a file");
			uploadLoader();
			return false;
		  }
		
		   else  {
			uploadLoader();
			// prepareBrandForm()
			toggleUpload();
			//Notify(alert, 'success', 'File Succesfully Uploaded')
			Notify(alert, "success", res.true);
			setLoading(true)
		
		  }
		});
	  };

	useEffect(()=>{

		if(loading == true){
			const rowData = operativeRow.data();
			brandTable.current.dataTable.clear().draw()
		supplierCtl.brands(rowData.id, data =>
			{
			
			if ((data.errorMessage || data.error) && data.errorCode !== "NOT_FOUND")
			{
				Notify(alert, "danger", data.errorMessage ?? data.error);
			} else
			{
				data.forEach(item => {
					supplierCtl.cardsByBrandBySupplier(item.supplierId, item.id, cardData =>
					{
						if ((cardData.errorMessage || cardData.error) && cardData.errorCode !== "NOT_FOUND")
						{
							Notify(alert, "danger", cardData.errorMessage ?? cardData.error);
						} else
						{
							if (cardData.errorCode !== "NOT_FOUND")
							{
								item.cards = cardData.map(card => ({...card, status: 'edit'}))
							} else
							{
								item.cards = [];
							}
							brandTable.current.addRow(item);
						}
					});
				})
			}
			setTimeout(()=>{
				setLoading(false)

			},2000);
		});
	}
},[loading])

const handleOpenAddressInfo = (e) =>{
	e.preventDefault()
	setIsAddressInfoOpen(!isAddressInfoOpen);

}
const handleOpenPaymentMethod = (e)=>{
      e.preventDefault();
	  setIsPaymentOptions(!isPaymentOptions);
}
const handleFundThrshold = (e)=>{
	e.preventDefault();
	setIsFundThreshold(!isFundThreshold)
}
const handleOpenFeesAndDiscount = (e) =>{
	e.preventDefault();
	setisFeesandDiscount(!isFeesandDiscount);
}
const handleOpenContact = (e) =>{
      e.preventDefault()
	  setIsContactInfoOpen(!isContactInfoOpen);
}

const handleOpenbrandInfo = (e) =>{
      e.preventDefault()
	  setIsSupplierBrandInfo(!isSupplierBrandInfo);
}

useEffect(()=>{
	if(activeOp === "Add New"){
	  setIsAddressInfoOpen(true);
	  setIsPaymentOptions(true);
	  setisFeesandDiscount(true);
	  setIsContactInfoOpen(true);
	  setIsSupplierBrandInfo(true)
	  
	}

  },[activeOp,operativeRow?.data()?.id])

  const generalLoader = () =>{
	setTimeout(() => {
		setLoaderOne(false)
	}, 1500);
  }
  const adressLoader = () =>{
	setTimeout(() => {
		setLoaderTwo(false)
	}, 1500);
  }
  const paymentLoader = () =>{
	setTimeout(() => {
		setLoaderThree(false)
	}, 1500);
  }
  const fundLoader = () =>{
	setTimeout(() => {
		setLoaderFour(false)
	}, 1500);
  }
  const feesLoader = () =>{
	setTimeout(() => {
		setLoaderFive(false)
	}, 1500);
  }
  const contactLoader = () =>{
	setTimeout(() => {
		setLoaderSix(false)
	}, 1500);
  }
  const catalogLoader = () =>{
	setTimeout(() => {
	  setLoaderSeven(false)	
	}, 1500);
  }
  const uploadLoader = () =>{
	setTimeout(() => {
		setLoaderEight(false)	
	}, 1500);
  }
  const brandLoader = () =>{
	setTimeout(() => {
		setLoaderNine(false)	
	}, 1500);
  }
  const bulkUpload = () =>{
	setTimeout(() => {
		setLoaderTen(false)
	}, 1500);
  }

  const generalSupplierInfo = () =>{
      setLoaderOne(true)
	let basicInfo = !isSupplierAPI ? [
		{ label: "Supplier Name", property: "name", required: true },
		{ label: "Main Phone", property: "mainPhone", required: true, type: "phone" },
		{ label: "Website", property: "website", required: false, type: "url" },
		{ label: "Active Supplier", property: "active", required: false, type: "check" },
		{ label: "EDT", property: "edt", type: "number" ,defaultValue:0}
	]

		: [
			{ label: "Supplier Name", property: "name", required: true },
			{ label: "Main Phone", property: "mainPhone", required: true, type: "phone" },
			{ label: "Website", property: "website", required: false, type: "url" },
			{ label: "Active Supplier", property: "active", required: false, type: "check" },
			{ label: "EDT", property: "edt", required: true, type: "number" }
		]


	const fv = new FormValidator(form.current, (type, message) => Notify(alert, type, message), basicInfo);

	if (!fv.isFormValid()){
		generalLoader();
		return;
	}
		

	const supplierData = fv.getDTO();
	supplierData.id = operativeRow.data().id;

	supplierCtl.update(supplierData, data => {
		if(data?.status === 403){
			toggleWarning();
			generalLoader();
			toggle();
		}
		if (data.errorMessage || data.error) {
			if(data?.error === "Server error response code: 403. Unable to parse response body."){
				generalLoader();
			}else{
				Notify(alert, "danger", data.errorMessage ?? data.error);
				generalLoader();
			}
		} else {
          Notify(alert,"success","General supplier info updated");
		  generalLoader();
		}

  })
}

const generalAdressInfo = () =>{
	setLoaderTwo(true)
	const av = new FormValidator(form.current, (type, message) => Notify(alert, type, message),
	[
		{ label: "Street and Number", property: "street", required: true },
		{ label: "City", property: "city", required: true },
		{ label: "Postal or Zip Code", property: "postalCode", input: "zipcode", required: true },
		{ label: "Country", property: "countryId", required: true, noVal: "-1" }
	]
);

if (!av.isFormValid()){
	adressLoader();
	return;
	
}
	

const addressInfo = av.getDTO();
addressInfo.supplierId = operativeRow.data().id;

supplierCtl.updateAddress(addressInfo, addressData => {
		if (addressData.errorMessage || addressData.error) {
			if(addressData?.error === "Server error response code: 403. Unable to parse response body."){
				adressLoader();
			}else{
				Notify(alert, "danger", addressData.errorMessage ?? addressData.error);
				adressLoader()
			}
			
		} else{
			adressLoader();
			Notify(alert,"success","Update Address successfully")
		}
	})

	}

const generalPaymentOption = () =>{
	setLoaderThree(true)
	const pov = new FormValidator(form.current, (type, message) => Notify(alert, type, message),
			[
				{ label: "Payment Option", property: "paymentOptionId", input: "paymentTypeId", required: true, noVal: "-1" },
				{
					label: "Threshold Amount", property: "thresholdAmount", input: "paymentTypeAmount", required: true,
					ignoreCondition: { input: "paymentTypeId", type: "select", subType: { type: "dataset", property: "requiresAmount" }, value: "false" },
					defaultValue: "0"
				}
			]
		);

		if (!pov.isFormValid()){
			paymentLoader();
			return;
		}
		
		const paymentInfo = pov.getDTO();
		paymentInfo.supplierId = operativeRow.data().id;

		supplierCtl.updateThresholdAmount(paymentInfo, paymentData => {
			if (paymentData.errorMessage || paymentData.error) {
				if(paymentData?.error === "Server error response code: 403. Unable to parse response body."){
                 paymentLoader();
				}else{
					paymentLoader();
					Notify(alert, "danger", paymentData.errorMessage ?? paymentData.error);
				}
				
			} else{
				paymentLoader();
                 Notify(alert,"success","Payment option update successfully")
			}
		})
}

const handleFundThreshold = ()=>{
	setLoaderFour(true)
	let obj ={
	"supplierId":supplierId,
	"thresholdAmount":thresholdValue,
	"supplierBalance":supplierBalance || 0
}
supplierCtl.createFund(obj,(data)=>{
	if(data && !data.error){
		fundLoader();
		Notify(alert,"success","Create Fund threshold successfully")
		const fund = {
		id:data?.id,
        supplierName:data?.supplierName,
		threshold:data?.thresholdAmount,
		Balance:data?.supplierBalance
		}
		setFundTableData(fund)
	}else{
		fundLoader();
		Notify(alert,"danger",data?.errorMessage ?? data?.error)
	}
})

}


const deleteFund = (del)=>{
	const id = del.data().id
 supplierCtl.deleteFund(id,(data)=>{
	if(data && !data.error){
		del.remove().draw();
		Notify(alert,"success","Fund threshold delete successfully")
	}else{
    Notify(alert,"danger",data?.errorMessage ?? data?.error)
	}
 })
}

const handleToggleAndReset = () => {
	toggle(); 
	setThrsholdValue(""); 
  }


const generalFeeAndDiscount = ()=>{
	setLoaderFive(true)
	const fdv = new FormValidator(form.current, (type, message) => Notify(alert, type, message),
			[
				{
					label: "Purchase Fee", property: "purchaseFee", required: false, defaultValue: 0,
					conditions: [
						{ op: "gt", value: "-1" }
					]
				},
				{
					label: "Purchase Discount", property: "purchaseDiscount", required: false, defaultValue: 0,
					conditions: [
						{ op: "gt", value: "-1" }
					]
				}
			]
		);

		if (!fdv.isFormValid()){
			feesLoader();
           return;
		}
			
		const feeInfo = fdv.getDTO();
        feeInfo.supplierId = operativeRow?.data()?.id;

		supplierCtl.updateFeeAndDiscount(feeInfo, feeData => {
			if (feeData.errorMessage || feeData.error) {
				if(feeData?.error === "Server error response code: 403. Unable to parse response body."){
                  feesLoader();
				}else{
					Notify(alert, "danger", feeData.errorMessage ?? feeData.error);
					feesLoader();
				}
				
			} else{
               Notify(alert,"success","Fees And Discount Update successfully");
			   feesLoader();
			}
		})
}

const generalContactInfo = () =>{
	const ID = operativeRow?.data()
	saveSendContact(contactTable.current.dataTable.data().toArray(),ID)
}

const generalSaveLayout = () =>{
	const supplierData = operativeRow.data()
	saveLayout(supplierData)
}

const generalBrandAdd = ()=>{
	setLoaderNine(true)
	if(cardTypeTable.current){
	}

	if(!latestAddedBrand?.brands && !latestAddedBrand.cards){
		Notify(alert, "danger", "Add new brand before save");
		brandLoader();
		return;
	}
	
	const dataCount = brandTable.current.dataTable
	.data()
	.toArray();
	const data = operativeRow?.data();
	latestAddedBrand.supplierId = data.id;
	let newCardIter = latestAddedBrand.cards
	newCardIter.supplirId = data.id;
	let supplierItem = latestAddedBrand.cards[0].supplierItem

	if(dataCount.length < 1){
		Notify(alert,"danger","Atleast one brand should be added");
		brandLoader();
		return;
	}
	if(latestAddedBrand?.cards[0]?.status == "new"){
		supplierCtl.addBrand(latestAddedBrand,(addData)=>{
			if(addData && !addData.error){
				brandLoader();
	           Notify(alert,"success","Brand added successfully")
			   setLatestAddedBrand({})
				newCardIter.supplierBrandId = addData.id
				sendCardTypes(addData,data,newCardIter)
				
				}else{
				brandLoader();
				Notify(alert,"error",addData?.errorMessage ?? addData?.error)
			  }
	 })
	}else{
		supplierCtl.updateBrand(latestAddedBrand,(editData)=>{
			if(editData && !editData.error){
				brandLoader()
				setLatestAddedBrand({})
				Notify(alert,"success","Brand update successfully")
				sendCardTypes(editData,data,newCardIter)
				
			}else{
				brandLoader()
				Notify(alert,"error",editData?.errorMessage ?? editData?.error)
			}
		})
	}
	

}

	return (<>
		<NotificationAlert ref={alert} />
		<ConfirmationAlert stayModal={stayModal} openModal={showAlertMessage} leaveModal={leaveAllModal} suppMessage={deleteFlag} onDeleteSuplierBrand={() => onDeleteSuplierBrand()} />
		<div className="content">
			<Row>
				<Col md="12">
					<Card>
						<CardHeader className="d-flex justify-content-between">
							<Row>
								<CardTitle tag="h5">Ncentiva Platform Supplier Management</CardTitle>
							</Row>
						
								{/* {!accessRoles.includes("ACCOUNTANT_MANAGER") ? */}
									<Row className="justify-content-end">
										<Col md='auto'>
											<MotionButton initial={{ x: "-500%", opacity: 0 }} 
											animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }} className="supplier_view btn btn-primaryTwo"  onClick={prepareToAdd}>
												<i className="fas fa-folder-open" />{' '}Add new supplier
											</MotionButton>
										</Col>
										<Col md='auto'>
											<MotionButton initial={{ x: "-500%", opacity: 0 }}
											animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }} className="supplier_view btn btn-primaryTwo"  onClick={toggleHistory}>
												<i className="fas fa-history" />{' '}View order history
											</MotionButton>
										</Col>
									</Row>
						</CardHeader>
						<CardBody>
							
					       {loader ? 
								<div className='d-flex justify-content-center align-items-center flex-column vh-50'>
								   <div className="spinner-border text-muted text-center"></div>
								</div>
							:	
						<div className="data_table_supplier">
							<DataTable ref={table} columns={header} data={null}
								options={{
									createdRow: onRowCreated,
									drawCallback: onDraw,
									saveState: false,
								}}
								addEditButton={{ callback: prepareToEdit, viewMode: false }}
								addDashButton={{ callback:  goToDashboard}}
								onChildRowChange={onChildRow}
								enableSelectFilters={true}
							/>
							</div>
                        }
						</CardBody>
					</Card>
				</Col>
			</Row>
			<Modal isOpen={modal} toggle={toggle} backdrop="static" centered={true} size="xxlg" style={{ maxWidth: "80% !important" }} onOpened={prepareForm}>
				<ModalHeader toggle={handleToggleAndReset} className="custom_header_colourTwo">{activeOp} Supplier</ModalHeader>

				<ModalBody>
					<Form innerRef={form}>
						<Row className="justify-content-between align-items-center">
						<Col md="6">
							<p className="card-just-text">
							{activeOpText}
						    </p>
							</Col>
						
						</Row>
					
						
						<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo d-flex py-1 align-items-center">General Supplier Information</h6>
						<Input type="hidden" name="supplierId" id="supplierId" value="" />
						<Row form>
							<Col md={6}>
								<FormGroup>
									<Label for="name">Supplier Name<span className="required-asterisk">*</span></Label>
									<Input type="text" name="name" id="name" placeholder="Name of the company" maxLength="70" />
								</FormGroup>
							</Col>
							<Col md={6}>
								<FormGroup>
									<Label for="mainPhone">Main Phone<span className="required-asterisk">*</span></Label>
									<Input type="tel" name="mainPhone" id="mainPhone" placeholder="Company's main phone number" maxLength="14" />
								</FormGroup>
							</Col>
						</Row>
						<Row form>
							<Col md={6}>
								<FormGroup>
									<Label for="website">Website<span className="required-asterisk">*</span></Label>
									<Input type="url" name="website" id="website" placeholder="Company website address" maxLength="250" />
								</FormGroup>
							</Col>
							<Col md={6}>
								<Row>
									<Col md={5} className=''>
										<FormGroup>
											<Label for="active">Is supplier active in the platform?</Label>
											<CustomInput id="active" name="active" type="switch" label="Active Supplier" className="pt-1" />
										</FormGroup>
									</Col>
									<Col md={7} className='p-0'>
										<FormGroup >
											<Label for="supplierType">Is supplier active with an API?</Label>
											<Row>
												<Col md='auto' className="pt-1">
													<CustomInput id="supplierType" name="supplierType" type="switch" label="non API"
														onChange={(e) => setIsSupplierAPI(e.target.checked)}
													/>
												</Col>

												{isSupplierAPI &&
													<Col md={6}>
														<FormGroup row>
															<Label for="edt" sm={2}>EDT</Label>
															<Col sm='6' className="mt-1">
																<Input type="number" name="edt" id="edt" placeholder="weeks" className="py-1" />
															</Col>
														</FormGroup>
													</Col>
												}
											</Row>
										</FormGroup>
									</Col>
								</Row>
								{
									activeOp === "Add New" ? null
									:
								
								<Row>
								<Col md={12} className="d-flex justify-content-end">
									<Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={generalSupplierInfo} disabled={loaderOne}> {!loaderOne && "Save"} {loaderOne && 
										<Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
											margin: "0px 8px"
										}}
									/>
										}</Button>
									</Col>
								</Row>
					            }
							</Col>
						</Row>
						<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo py-1 d-flex align-items-center"  onClick={activeOp === "Add New" ? null : handleOpenAddressInfo}>
						{activeOp !== "Add New" && (
							<>
								<i
								className={
									isAddressInfoOpen
										? "fas fa-chevron-up"
										: "fas fa-chevron-down"
								}
							/>
							&nbsp;&nbsp;
						</>
						)}Supplier Address Information
							</h6>
							<Collapse isOpen={isAddressInfoOpen}>
							<Row form>
							<Col md={6}>
								<FormGroup>
									<Label for="street">Street and Number<span className="required-asterisk">*</span></Label>
									<Input type="text" name="street" id="street" placeholder="Street name, number and internal number" maxLength="70" />
								</FormGroup>
							</Col>
							<Col md={6}>
								<FormGroup>
									<Label for="city">City<span className="required-asterisk">*</span></Label>
									<Input type="text" name="city" id="city" placeholder="City" maxLength="50" />
								</FormGroup>
							</Col>
						</Row>
						<Row form>
							<Col md={6}>
								<FormGroup>
									<Label for="zipcode">Postal or Zip Code<span className="required-asterisk">*</span></Label>
									<Input type="text" name="zipcode" id="zipcode" placeholder="Zip Code" maxLength="7" />
								</FormGroup>
							</Col>
							<Col md={6}>
								<FormGroup>
									<Label for="countryId">Country<span className="required-asterisk">*</span></Label>
									<Input type="select" name="countryId" id="countryId">
										<option value="-1">Select a country</option>
									</Input>
								</FormGroup>
							</Col>
						</Row>
						{
							activeOp === "Add New" ? null
							:
						
						<Row>
						<Col md={12} className="d-flex justify-content-end">
							<Button type="button"className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={generalAdressInfo} disabled={loaderTwo}>{!loaderTwo &&"Save"}{
								loaderTwo && 
								<Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
											margin: "0px 8px"
										}}
									/>
								}</Button>
							</Col>
						</Row>
                      }
							</Collapse>
					
						<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo" onClick={activeOp === "Add New" ? null : handleOpenPaymentMethod}>
							{activeOp !== "Add New" && (
								<>
								<i
								className={
									isPaymentOptions
										? "fas fa-chevron-up"
										: "fas fa-chevron-down"
								}
							/>
							&nbsp;&nbsp;
								</>
							)}Supplier Payment Options
							</h6>
							<Collapse isOpen={isPaymentOptions}>
							<Input type="hidden" name="paymentOptId" id="paymentOptId" value="" />
						<Row form>
							<Col md={6}>
								<FormGroup>
									<Label for="paymentTypeId">Payment Option<span className="required-asterisk">*</span></Label>
									<Input type="select" name="paymentTypeId" id="paymentTypeId" onChange={onPaymentTypeChange}>
										<option value="-1">Select a payment type</option>
									</Input>
								</FormGroup>
							</Col>
							<Col md={6}>
								<FormGroup id="paymentTypeCtl">
									<Label for="paymentTypeAmount">Threshold Amount</Label>
									<Input
										type="number"
										name="paymentTypeAmount"
										id="paymentTypeAmount"
										placeholder="Maximum expendable amount"
										disabled={accessRoles.includes("SYSTEM_MANAGER", "INTERNAL_MANAGER", "INTERNAL", "PRODUCT_MANAGER",) ? true : false}
									/>
								</FormGroup>
							</Col>
						</Row>
						{
							activeOp === "Add New" ? null
							:
						
						<Row >
						<Col md={12} className="d-flex justify-content-end" id="saveButton">
							<Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={generalPaymentOption} disabled={loaderThree}>{ !loaderThree && "Save"}
								{
									loaderThree && 
									<Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
											margin: "0px 8px"
										}}
									/>
								}
							</Button>
							</Col>
						</Row>
						}
							</Collapse>

							<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo" onClick={activeOp === "Add New" ? null : handleFundThrshold}>
							{activeOp !== "Add New" && (
								<>
								<i
								className={
									isFundThreshold
										? "fas fa-chevron-up"
										: "fas fa-chevron-down"
								}
							/>
							&nbsp;&nbsp;
								</>
							)}Supplier Fund  Threshold
							</h6>
							<Collapse isOpen={isFundThreshold} >
							<Row form>
							<Col md={6}>
								<FormGroup>
									<Label for="name">Supplier Name<span className="required-asterisk"></span></Label>
									<Input type="text"  placeholder="Name of the company" maxLength="70" value={supplierName} onChange={handleSupplierName} disabled/>
								</FormGroup>
							</Col>
							<Col md={6}>
								<FormGroup>
									<Label for="name">Threshold<span className="required-asterisk">*</span></Label>
									<Input type="text"  placeholder="Enter threshold value" maxLength="70" value={thresholdValue} onChange={handleThrsholdValue}/>
								</FormGroup>
							</Col>
							</Row>
							<Row form>
							<Col md={6}>
								<FormGroup>
									<Label for="name">Supplier Balance<span className="required-asterisk"></span></Label>
									<Input type="text"  placeholder="Supplier balance" maxLength="70" value={supplierBalance} onChange={handleSupplierBalace} disabled/>
								</FormGroup>
							</Col>
							</Row>
							{
							activeOp === "Add New" ? null
							:
						
						<Row >
						<Col md={12} className="d-flex justify-content-end" id="saveButton">
							<Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={handleFundThreshold} disabled={loaderFour}>{!loaderFour && "Create"}{
								loaderFour && <Spinner
								as="span"
								animation="border"
								size="sm"
								role="status"
								aria-hidden="true"
								style={{
									margin: "0px 8px"
								}}
							/>
								}</Button>
							</Col>
						</Row>
						}

						{/* <DataTable 
						ref={fundTable}
						columns={headerFund}
						data={fundTableData}
						options={{
							dom: "tip",
							saveState: false,
						   }}
						addRemoveButton={{
							callback: deleteFund,
							viewMode: false,
						  }}
						/> */}
							</Collapse>
						
						<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo py-1 d-flex align-items-center" onClick={activeOp === "Add New" ? null : handleOpenFeesAndDiscount}>
							{activeOp !== "Add New" && (
								<>
								<i
								className={
									isFeesandDiscount
										? "fas fa-chevron-up"
										: "fas fa-chevron-down"
								}
							/>
							&nbsp;&nbsp;
								</>
							)}Supplier Fees and Discounts
							</h6>
							<Collapse isOpen={isFeesandDiscount}>
							<Input type="hidden" name="feeId" id="feeId" value="" />
						  <Row form>
							<Col md={6}>
								<FormGroup>
									<Label for="purchaseFee">Purchase Fee</Label>
									<Input type="number" name="purchaseFee" id="purchaseFee" placeholder="Fee" />
								</FormGroup>
							</Col>
							<Col md={6}>
								<FormGroup>
									<Label for="purchaseDiscount">Purchase Discount (in percentage e.g. 15 for 15%)</Label>
									<Input type="number" name="purchaseDiscount" id="purchaseDiscount" placeholder="Discount" />
								</FormGroup>
							</Col>
						</Row>
							{
								activeOp === "Add New" ? null
								:
							
							<Row >
							<Col md={12} className="d-flex justify-content-end" id="saveButton">
								<Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={generalFeeAndDiscount} disabled={loaderFive}>{!loaderFive && "Save"}{
									loaderFive && <Spinner
									as="span"
									animation="border"
									size="sm"
									role="status"
									aria-hidden="true"
									style={{
										margin: "0px 8px"
									}}
								/>
									}</Button>
								</Col>
							</Row>
							}
							</Collapse>
						
						<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo py-4 d-flex align-items-center" onClick={() => setApiCredInfo(!apiCredInfo)} style={{ cursor: "pointer" }}>
							<i className={apiCredInfo ? "fas fa-chevron-up" : "fas fa-chevron-down"} />&nbsp;&nbsp;Supplier API Credentials (Optional, requires software support)
						</h6>
						<Collapse isOpen={apiCredInfo}>
							<APICredential handleCredential={setBulkLayout} />
						</Collapse>
						<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo" onClick={activeOp === "Add New" ? null : handleOpenContact}>
							{activeOp !== "Add New" && (
								<>
								<i
								className={
									isContactInfoOpen
										? "fas fa-chevron-up"
										: "fas fa-chevron-down"
								}
							/>
							&nbsp;&nbsp;
								</>
							)}Supplier Personal Contact Information<span className="required-asterisk">*</span>
							</h6>
							<Collapse isOpen={isContactInfoOpen}>
							<Row form className="justify-content-end">
							<Col md={12}>
							<div className="table-responsive">
								<DataTable ref={contactTable}
									data={null}
									columns={[
										{
											title: "Contact Type", data: "contactTypeId", render: data => {
												const ct = contactTypes.find(item => item.id === parseInt(data));
												return !!ct ? ct.name : contactTypes.length > 0 ? "No Contact Type" : "Loading...";
											}
										},
										{ title: "First Name", data: "firstName", render: $.fn.dataTable.render.text() },
										{ title: "Last Name", data: "lastName", render: $.fn.dataTable.render.text() },
										{ title: "Email", data: "email", render: $.fn.dataTable.render.text() }
									]}
									addEditButton={{
										callback: (row) => {
											setActiveContact(row);
											setContactModal(true);
										}, viewMode: false
									}}
									options={{ dom: "tip" }} /></div>
								<BaseModal okButtonTag="Add Contact" cancelButtonTag="Close" onOk={addContact}
									onCancel={() => setContactModal(false)} trigger={contactModal}
									toggle={() => setContactModal(!contactModal)}
									onOpened={prepareContactForm}
									size="lg"
									hideCancel={!!activeContact}
									title="Add Supplier Contacts"
									okButtonClass="btn btn-primaryTwo"
    								cancelButtonClass="btn btn-primaryTwo"
									>
									<ContactsCtl formRef={contactForm} />
								</BaseModal>
							</Col>
						</Row>
						<Row form>
							<Col md="12" className="justify-content-end text-right">
								<Button type="button" className="btn btn-primaryTwo" onClick={() => {
									setActiveContact(null);
									setContactModal(true);
								}}>Add contact</Button>

									{
									activeOp === "Edit" && (contactTable.current?.dataTable.data().toArray().length > 0) ? (
										<Button type="button" className="btn btn-primaryTwo" style={{ cursor: "pointer" }} onClick={generalContactInfo} disabled={loaderSix}>{!loaderSix && "Save"}{
											loaderSix && <Spinner
											as="span"
											animation="border"
											size="sm"
											role="status"
											aria-hidden="true"
											style={{
												margin: "0px 8px"
											}}
										/>
										}</Button>
									) : null
									}

							</Col>
							
						</Row>
						  
							</Collapse>
						

						<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo py-2 d-flex align-items-center" onClick={activeOp === "Add New" ? null : handleOpenbrandInfo}>
							{activeOp !== "Add New" && (
                            <>
							<i
								className={
									isSupplierBrandInfo
										? "fas fa-chevron-up"
										: "fas fa-chevron-down"
								}
							/>
							&nbsp;&nbsp;
								
							</>
							)}Supplier Brand Information<span className="required-asterisk">*</span>
							</h6>
							<Collapse isOpen={isSupplierBrandInfo}>
							<Row>
							
							<Col md="12" className="justify-content-end text-right">
							<Button
						  className="mr-3 btn btn-primaryTwo"
						  style={{ cursor: "pointer" }}
						  type="button"
						  onClick={()=>downloadCsv(operativeRow)}
						  disabled={loaderSeven}
						>
						  { !loaderSeven && "API CATALOG"}
						  {
							loaderSeven && 
							        <Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
											margin: "0px 8px"
										}}
									/>
						  }
						</Button>
							<Button
                              className="mr-3 btn btn-primaryTwo"
                              style={{ cursor: "pointer" }}
                              type="button"
                               onClick={() => toggleUpload()}
                            >
                              UPLOAD FILE
                            </Button>
								<Button type="button" className="btn btn-primaryTwo" onClick={() => {setBrandModal(true);setIsSupplierBrandInfo(true)}}>Add Brand</Button>
							</Col>
							</Row>
							<Row form>
							<Col md={12}>
							<div className="table-responsive">
								<DataTable id="example" ref={brandTable}
										   data={null}
										   columns={[
											   {
												   title: "Brand", data: "brandId", render: data =>
												   {
													   const brand = brands.find(item => item.id === parseInt(data)) ?? {name:null  };
														 return `${Utils.deleteTags(brand.name) ?? "Invalid brand"}`;

											}
										},
										{
											title: "Fees and Discounts", data: "purchaseFee", render: (data, type, rowData) => {
												if (!!rowData.purchaseFee || !!rowData.purchaseDiscount)
													return `Fee: ${Utils.deleteTags(rowData.purchaseFee) ?? "No override"}<br/>Discount: ${!!rowData.purchaseDiscount ? `${rowData.purchaseDiscount}%` : "No override"}`;
												else
													return "No Override";
											}
										},
										{
											title: 'Currency', data: "currency", render:(data) =>{
												if(data){
												  return `${data}`
												}else {
													return `USD`
												}
											}
											
										},
										{
											title: "Purchase Limits", data: "minimumAmount", render: (data, type, rowData) => {
												if (!!rowData.minimumAmount || !!rowData.maximumAmount || !!rowData.minimumQuantity || !!rowData.maximumQuantity)
													return `Amount: ${Utils.deleteTags(rowData.minimumAmount) ?? "No override"} / ${!!rowData.maximumAmount ?? "No override"}<br/>Quantity: ${rowData.minimumQuantity ?? "No override"} / ${!!rowData.maximumQuantity ?? "No override"}`;
												else
													return "No Override";
											}
										},
										{
											title: "Card Types", data: "cards", render: (data) => {
												if (data) {
													return "<ul>" + data.map(item => {
														const cardType = cardTypes.find(card => card.id === parseInt(item.giftCardTypeId));
														return `<li>${!!cardType ? Utils.deleteTags(cardType.productName) : "Invalid card type"} /  ${!!cardType?.sku ? cardType?.sku : "Not available"}</li>`;
													}).join("") + "</ul>";
												}
												return "No card data found";
											}
										}
									]}
									addEditButton={{
										callback: (row) => {
											setActiveBrand(row);
											setBrandModal(true);
										}, viewMode: false
									}}
									addDeleteButton={{
										callback: (row) => {
											setShowAlertMessage(true);
											setDeleteFlag(row);
										},
										viewMode: false
									}}

									options={{ dom: "tip" }} />
									</div>
								<BaseModal okButtonTag="Add Brand" cancelButtonTag="Close" onOk={addBrand}
									onCancel={() => { setBrandModal(false); setActiveBrand(null); setSelectedOption({}); }} trigger={brandModal}
									toggle={() => setBrandModal(!brandModal)}
									onOpened={prepareBrandForm}
									size="lg"
									title="Add Supplier Brands"
									okButtonClass="btn btn-primaryTwo"
    								cancelButtonClass="btn btn-primaryTwo">


									<BrandsCtl
										addCardType={addCardType}
										brandList={brandFilter}
										brandsSelect={brandsSelect}
										cardTypeForm={cardTypeForm}
										cardTypeTable={cardTypeTable}
										formRef={brandForm}
										selectedBrand={selectedOption}
										setSelectedBrand={setSelectedOption}
										setDisableSelect={setDisableSelect}
										setExtraCardInfo={(data) => setExtraCardTypeInfo(data)}
										setExtraBrandInfoSup={(data) => setExtraBrandInfo(data)}
										setIsVariable={setIsVariable}
										disableSelect={disableSelect}
										operation={brandOperation}
										supplier={operativeRow ? operativeRow.data() : null}
										token={token}
                                        amount={amount}
										productName={productName}
										currencyId={currencyId}
										currencyName={currencyName}
										minimumAmount={minimumAmount}
										maximumAmount={maximumAmount}
										setProductName={setProductName}
										setCurrencyId={setCurrencyId}
										setCurrencyName={setCurrencyName}
										setAmount={setAmount}
										setMinimumAmount={setMinimumAmount}
										setMaximumAmount={setMaximumAmount}

										mappings={mappings}
									/>
								</BaseModal>
							</Col>
						</Row>
						<Row>
						<Col md="6">
						</Col>
						{
						activeOp === "Add New" ? (
							<Col md="6" className="d-flex justify-content-end">
							<Button type="button" className="btn btn-primaryTwo" onClick={() => {setBrandModal(true);setIsSupplierBrandInfo(true)}}>Add Brand</Button>
						</Col>	
						):(
						null
						)	
						}
						
							
						</Row>
					   
						{
							activeOp === "Edit" ? (
                       <Row >
						<Col md={12} className="d-flex justify-content-end" id="saveButton">
							<Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={generalBrandAdd} disabled={loaderNine}>{!loaderNine && "Save"}{
								loaderNine && 
                                     <Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
											margin: "0px 8px"
										}}
									/>
                             }</Button>
							</Col>
						</Row>
							)
							: null}
					   
							</Collapse>
						

					</Form>

					<Modal
                    isOpen={upload}
                    toggle={toggleUpload}
                    backdrop="static"
                    centered={true}
                    size="xl"
                  >
                    <ModalHeader toggle={toggleUpload} className="custom_header_colourTwo">
                      {activeOp} Brand
                    </ModalHeader>
                    <Form>
                      <ModalBody>
                        <div className={modalCSVcss.container}>
                          <div className="text">
						  <div className="tooltip-container" onMouseEnter={() => setShowTooltip(true)}
									onMouseLeave={() => setShowTooltip(false)} style={{ cursor: "pointer",marginLeft:"32px" }}>
								<p
									className="text-center tooltip-trigger mb-0"
									
								>
									<BsInfoCircle size={20}  />
								</p>
								{showTooltip && (
									<div className="tooltip-content">
									<p>
									You can download a template, select the information using the format, and delete the ones  you don’t need to add 
										</p>
									<p>Please select a file of type CSV and press Save.</p>
									</div>
								)}
    						</div>
							<p className="text_format">Instructions</p>
                          
                          </div>
                          <label
                            htmlFor="file"
                            className={modalCSVcss.formContainer}
                          >
                            <UploadIcon />
                            <span>File Upload CSV</span>
                            <input
                              type="file"
                              name=""
                              id="file"
                              className={modalCSVcss.dn}
                              onChange={handleFileChange}
                              // ref={file}
                              accept=".csv"
                            />
                          </label>

                          {fileCsv?.name && (
                            <div className={modalCSVcss.fileSelected}>
                              <p>
                                {fileCsv.name}{" "}
                                <span className="arrow">
                                  <img src={okIMG} alt="" />
                                </span>
                              </p>
                            </div>
                          )}
                        </div>
                        <p
                          className="dbuttonc"
                          style={{
                            color: "#2665F2",
                            fontWeight: "900",
                            cursor: "pointer",
                            fontSize: "18px",
                          }}
                         
                          onClick={() => {
                            downloadBrandLimit(operativeRow);
                          }}
                        >
                          Download Template
                        </p>
                      </ModalBody>
                      <ModalFooter>
                        <Button
                          type="button"
                          color="secondary"
                          onClick={toggleUpload}
                        >
                          Cancel
                        </Button>{" "}
                        <Button
                          type="submit"
                         className="btn btn-primaryTwo"
                          onClick={handleFileUpload}
						  disabled={loaderEight}
                        >
                          { !loaderEight && "Save"}
						  {
							loaderEight && 
							<Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
											margin: "0px 8px"
										}}
									/>
						  }
                        </Button>
                      </ModalFooter>
                    </Form>
                  </Modal>


					<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo py-1 d-flex align-items-center" onClick={() => setFileLayoutInfo(!fileLayoutInfo)} style={{cursor: "pointer"}}>
						<i className={fileLayoutInfo ? "fas fa-chevron-up" : "fas fa-chevron-down"}/>&nbsp;&nbsp;Supplier file layout for bulk uploads
					</h6>
					<Collapse isOpen={fileLayoutInfo}>
						<LayoutFileForm setLayout={setBulkLayout} />
						{
							activeOp === "Add New" ? null
							:
						
						<Row >
						<Col md={12} className="d-flex justify-content-end" id="saveButton">
							<Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={generalSaveLayout} disabled={loaderTen}>{!loaderTen && "Save"}{
                             loaderTen && 
							 <Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
											margin: "0px 8px"
										}}
									/>
							 }</Button>
							</Col>
						</Row>
						}
					</Collapse>
				</ModalBody>
				<ModalFooter className="flex-nowrap">
					<Col md={6} className="justify-content-start">
						<Button type="button" color="danger" onClick={removeSupplier}>Delete</Button>{' '}
					</Col>
					{ 
						activeOp === "Add New" ?
						<Col md={6} className="justify-content-end text-right">
						<Button type="submit" color="secondary" onClick={cancelOperation}>Cancel</Button>{' '}
						<Button type="button" className="btn btn-primaryTwo" onClick={finishOperation}>Save</Button>
					</Col>
					:
					<Col md={6} className="d-flex justify-content-end" style={{padding:"0px"}}>
					<Button
					  type="submit"
					 color="secondary"
					  onClick={cancelOperation}
					>
					  Close
					</Button>
				  </Col>
					 
					}
					
				</ModalFooter>
			</Modal>


			<Modal isOpen={confirmModal} toggle={toggleConfirm} backdrop="static">
				<ModalHeader className="bg-warning" toggle={toggleConfirm}>Remove Category</ModalHeader>
				<ModalBody>
					<p className="card-just-text">
						Are you sure you want to remove the category "{!!operativeRow && !!operativeRow.data ? operativeRow.data().name : ""}"?
					</p>
				</ModalBody>
				<ModalFooter>
					<Button type="button" color="secondary" onClick={toggleConfirm}>Cancel</Button>{' '}
					<Button type="button" color="primary" onClick={confirmDelete}>Yes</Button>
				</ModalFooter>
			</Modal>
		</div>
		<BaseModal
			hideOk={true}
			cancelButtonTag="Close"
			onCancel={() => setHistoryModal(false)} trigger={historyModal}
			toggle={toggleHistory}
			size="xl"
			title="Purchase Order History">
			<PurchaseOrdersBySupplier
				suppliers={suppliers}
				token={token}
				brands={cardTypes}
			/>
		</BaseModal>
		<Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
            <ModalHeader className="bg-warning" toggle={toggleWarning}>Access Denied</ModalHeader>
            <ModalBody>
                <p className="card-just-text">
				You do not have access to perform this action
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleWarning}>Close</Button>
            </ModalFooter>
        </Modal>
	</>);
}

export default SupplierView;
